import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const scrollToSection = (sectionId: string) => {
    // ホームページにいない場合は、まずホームページに移動してからスクロール
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* ブランド */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-blue-500 to-green-500 rounded-lg">
                <i className="ri-heart-pulse-line text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold">Liver Health Check</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              肝臓の健康セルフチェック・管理プラットフォーム
            </p>
          </div>

          {/* サービス */}
          <div>
            <h3 className="text-base font-bold mb-4">サービス</h3>
            <ul className="space-y-3 text-sm text-gray-400">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  サービスについて
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('how-it-works')}
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  使い方
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('faq')}
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  よくある質問
                </button>
              </li>
              <li>
                <a href="/check" className="hover:text-white transition-colors cursor-pointer">
                  無料チェック
                </a>
              </li>
            </ul>
          </div>

          {/* 法務 */}
          <div>
            <h3 className="text-base font-bold mb-4">法務情報</h3>
            <ul className="space-y-3 text-sm text-gray-400">
              <li>
                <a href="/terms" className="hover:text-white transition-colors cursor-pointer">
                  利用規約
                </a>
              </li>
              <li>
                <a href="/privacy" className="hover:text-white transition-colors cursor-pointer">
                  プライバシーポリシー
                </a>
              </li>
              <li>
                <a href="/disclaimer" className="hover:text-white transition-colors cursor-pointer">
                  免責事項
                </a>
              </li>
              <li>
                <a href="/commercial-law" className="hover:text-white transition-colors cursor-pointer">
                  特定商取引法に基づく表記
                </a>
              </li>
            </ul>
          </div>

          {/* お問い合わせ */}
          <div>
            <h3 className="text-base font-bold mb-4">お問い合わせ</h3>
            <ul className="space-y-3 text-sm text-gray-400">
              <li>
                <a href="/contact" className="hover:text-white transition-colors cursor-pointer">
                  お問い合わせフォーム
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* 免責事項 */}
        <div className="border-t border-gray-700 pt-8 mb-8">
          <div className="p-5 bg-gray-800 rounded-lg border border-gray-700">
            <p className="text-xs text-gray-400 leading-relaxed">
              <strong className="text-white">※ 重要な注意事項：</strong>
              本サービスは医療行為・診断・治療を行うものではありません。健康情報の提供を目的としています。
              体調不良や不安がある場合は、必ず医師・医療機関にご相談ください。
            </p>
          </div>
        </div>

        {/* コピーライト */}
        <div className="border-t border-gray-700 pt-8">
          <p className="text-sm text-gray-400 text-center">
            © 2026 MKメディカルパートナーズ. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
